/** @type {Styles} */
export const styles = {
  contentStyle: {
    paddingTop: 0,
    paddingBottom: 1,
    paddingX: 0,
  },
  containerStyle: {
    width: '100%',
    minHeight: 20,
    paddingX: 0,
  },
  summaryStyle: {
    marginLeft: 0,
    marginRight: 0,
  },
  radioGroupLabel: {
    color: 'gray.80',
  },
  filterWrapper: {
    marginTop: 3,
    width: '100%',
    paddingX: 0,
    '.MuiFormControlLabel-label': {
      color: 'gray.80',
      fontWeight: 400,
    },
    '.MuiFormControl-root': {
      width: '100%',
      padding: 0,
      margin: 0,
    },
    '.MuiRadioGroup-root': {
      width: '100%',
    },
  },
  columnsFilters: {
    width: '100%',
  },
}
